import React from 'react'
import { observer } from 'mobx-react-lite'
import PaginationControls from './../../../../components/content/PaginationControls/PaginationControls.component'
import ContentHtml from './../../../../components/content/ContentHtml/ContentHtml.component'
import Store from './../../store/RoyalRings.store'
import { MDBBtn, MDBIcon } from 'mdb-react-ui-kit'

import './List.component.scss'

const List = () => {
  const onRingTypeToggle = ringType => {
    Store.setFilterRingType(ringType)
  }

  const onHeaderClick = field => {
    Store.setSorting(field)
  }

  const getSortIcon = field => {
    if (Store.sortField !== field) return null
    return Store.sortDirection === 'ASC' ? '▲' : '▼'
  }

  const getRingTypeLabel = ringType => {
    switch (ringType) {
      case 'ceo':
        return 'CEO'
      case 'leader':
        return 'Leader'
      case 'agent':
        return 'Agent'
      default:
        return ringType
    }
  }

  const formatThreshold = threshold => {
    if (threshold >= 1000000) {
      return `${(threshold / 1000000).toFixed(1)}MM`
    } else if (threshold >= 1000) {
      return `${(threshold / 1000).toFixed(0)}K`
    }
    return threshold
  }

  const formatDate = dateStr => {
    if (!dateStr) return 'N/A'
    return new Date(dateStr).toLocaleDateString()
  }

  return (
    <div id='ListComponent'>
      <ul className='recipient-options'>
        <li>
          <div className='toggle-filter'>
            <label className='filter-label'>Filter By Ring Type:</label>
            <div className='toggle-switch'>
              <button className={Store.filterRingType === null ? 'active' : ''} onClick={() => onRingTypeToggle(null)}>
                All
              </button>
              <button
                className={Store.filterRingType === 'ceo' ? 'active' : ''}
                onClick={() => onRingTypeToggle('ceo')}
              >
                CEO
              </button>
              <button
                className={Store.filterRingType === 'leader' ? 'active' : ''}
                onClick={() => onRingTypeToggle('leader')}
              >
                Leader
              </button>
              <button
                className={Store.filterRingType === 'agent' ? 'active' : ''}
                onClick={() => onRingTypeToggle('agent')}
              >
                Agent
              </button>
            </div>
          </div>
        </li>
        <li>
          <div className='notes'>
            <ContentHtml contentSlug='royal-ring-bro-instructions' />
          </div>
        </li>
      </ul>

      <ul className='recipient-list'>
        <li>
          <div className='rr-id sortable' onClick={() => onHeaderClick('id')}>
            ID {getSortIcon('id')}
          </div>
          <div className='rr-user sortable' onClick={() => onHeaderClick('user_id')}>
            User {getSortIcon('user_id')}
          </div>
          <div className='rr-ring-type sortable' onClick={() => onHeaderClick('ring_type')}>
            Ring Type {getSortIcon('ring_type')}
          </div>
          <div className='rr-threshold sortable' onClick={() => onHeaderClick('ring_threshold')}>
            Threshold {getSortIcon('ring_threshold')}
          </div>
          <div className='rr-received sortable' onClick={() => onHeaderClick('received_at')}>
            Received At {getSortIcon('received_at')}
          </div>
          <div className='rr-notified sortable' onClick={() => onHeaderClick('notified_at')}>
            Notified At {getSortIcon('notified_at')}
          </div>
          <div className='rr-btns'></div>
        </li>
        {Store.isLoading || Store.isSearching ? (
          <li className='loading-row'>
            <div className='loading-text'>Loading...</div>
          </li>
        ) : Store.Recipients.length === 0 ? (
          <li className='empty-row'>
            <div className='empty-text'>No recipients found</div>
          </li>
        ) : (
          Store.Recipients.map((Recipient, idx) => {
            return (
              <li key={`recipient-list-${Recipient.id()}-${idx}`}>
                <div className='rr-id'>{Recipient.id()}</div>
                <div className='rr-user'>
                  {Store.getUserNameByRecipient(Recipient)}
                  <span className='user-id-subtext'>(ID: {Recipient.get('user_id')})</span>
                </div>
                <div className='rr-ring-type'>{getRingTypeLabel(Recipient.get('ring_type'))}</div>
                <div className='rr-threshold'>{formatThreshold(Recipient.get('ring_threshold'))}</div>
                <div className='rr-received'>{formatDate(Recipient.get('received_at'))}</div>
                <div className='rr-notified'>{formatDate(Recipient.get('notified_at'))}</div>
                <div className='rr-btns'>
                  <MDBBtn
                    type='button'
                    size='sm'
                    color='primary'
                    disabled={
                      Store.isLoading ||
                      Store.isSearching ||
                      Store.isSaving ||
                      (Store.EditingRecipient && parseInt(Store.EditingRecipient.id()) !== parseInt(Recipient.id()))
                    }
                    onClick={() => Store.edit(Recipient)}
                  >
                    <MDBIcon icon='edit' /> Edit Bio
                  </MDBBtn>
                </div>
              </li>
            )
          })
        )}
      </ul>
      <div className='pagination-wrapper'>
        <PaginationControls
          pagination={Store.recipientPagination}
          onPageSelect={pagination => Store.searchRecipients({ pagination })}
        />
      </div>
    </div>
  )
}

export default observer(List)
